import { styled } from '@vebox/etui-system';
import { _ as _objectWithoutProperties, a as _objectSpread2 } from './_rollupPluginBabelHelpers-3b7bd988.js';
import { Ul } from '@vebox/etui-system-elements';

const _excluded = ["theme"];
const TreeViewItemUl = styled(Ul).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    ml: `${theme.spacing.xlg}`,
    p: 0
  }, props);
})`
  list-style-type: none;
`;

export { TreeViewItemUl as T };
